import Link from "next/link";
import { routes } from "src/shared/routes";
import { useRouterExt } from "src/components/reusable/hooks/useRouterExt";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

const PLATFORM_TERMS_URL = "https://www.attend.tech/terms-of-use";
const PLATFORM_PRIVACY_URL = "https://www.attend.tech/privacy-policy";

export const FAQS: TTeamConfig["LANGUAGES"]["FAQS"] = [
  {
    question: "What is the Kansas City Royals Fountain Pass?",
    answer:
      "The Kansas City Royals Fountain Pass is a flexible ticket plan that gives you access to Royals home games throughout the season for one simple price.",
    group: "OVERVIEW",
  },
  {
    question: "How does it work?",
    answer:
      "Once you purchase your pass, you'll be able to claim tickets for the eligible games you'd like to attend directly from your account, while supplies last.",
    group: "OVERVIEW",
  },
  {
    question: "What games are included?",
    answer:
      "Eligible games are listed in your account. The number of available games may vary based on availability throughout the season.",
    group: "OVERVIEW",
  },
  {
    question: "Are seats guaranteed for every game?",
    answer:
      "Seats are available on a first-come, first-served basis for eligible games. We recommend claiming your seats as soon as a game becomes available.",
    group: "SEAT/TICKET INFORMATION",
  },
  {
    question: "Where will my seats be?",
    answer:
      "Seat locations are assigned based on availability and may vary from game to game.",
    group: "SEAT/TICKET INFORMATION",
  },
  {
    question:
      "If I buy two or more passes, will my seats be next to each other?",
    answer:
      "Yes, passes purchased together will be seated next to each other as long as they are the same type of pass.",
    group: "SEAT/TICKET INFORMATION",
  },
  {
    question: "How do I get my tickets?",
    answer:
      "Once you claim tickets for a game, they will be delivered to your Kansas City Royals ticket account prior to the game.",
    group: "SEAT/TICKET INFORMATION",
  },
  {
    question: "Can I transfer my tickets?",
    answer:
      "Tickets claimed through the pass are intended for the passholder's use. Please contact us if you have questions about attending with a guest.",
    group: "OTHER",
  },
  {
    question: "Who do I contact with questions?",
    answer:
      "If you have any questions about your pass, use the chat button in the bottom corner of the page to reach our support team.",
    group: "OTHER",
  },
];

export const REGISTRATION_TERMS_AND_CONDITION = () => (
  <>
    By creating an account, you agree to receive account-related notification
    and marketing communication from the Kansas City Royals and you confirm that
    you have read and agree to the platform&apos;s{" "}
    <Link target="_blank" href={PLATFORM_TERMS_URL}>
      Terms &amp; Conditions
    </Link>{" "}
    and{" "}
    <Link target="_blank" href={PLATFORM_PRIVACY_URL}>
      Privacy Policy
    </Link>
    .
  </>
);

export const TERMS_AND_CONDITION = () => (
  <>
    By checking the box you agree to receive notifications regarding your
    purchase and to the{" "}
    <Link target="_blank" href={PLATFORM_TERMS_URL}>
      Terms &amp; Conditions
    </Link>{" "}
    and{" "}
    <Link target="_blank" href={PLATFORM_PRIVACY_URL}>
      Privacy Policy
    </Link>
    .
  </>
);

export const PASS_PURCHASE_SUCCESS_MESSAGE: TTeamConfig["LANGUAGES"]["PASS_PURCHASE_SUCCESS_MESSAGE"] =
  {
    TITLE: () => (
      <>
        You&apos;re all set to experience the action! Don&apos;t forget to
        confirm attendance here on game day!
      </>
    ),
    DESCRIPTION: () => {
      const router = useRouterExt();
      return (
        <>
          Friends don&apos;t leave friends behind.{" "}
          <b>
            <u>
              <span
                onClick={() => router.pushSchema(routes.my_group)}
                style={{ cursor: "pointer" }}
              >
                Invite your friends
              </span>
            </u>
          </b>{" "}
          and enjoy games together.
        </>
      );
    },
  };
